<template>
  <div class="simulation-options">
    <section class="simulation-summary">
      <div class="c-inner">
        <nav class="summary-nav">
          <ul class="summary-list">
            <template v-for="person in insuredPersons" :key="person.ID">
              <li class="summary-item">
                <button
                  type="button"
                  :class="'summary-item__btn' + addHere(person.ID)"
                  @click="changePerson(person.ID)"
                >
                  {{ person.LABEL }}
                </button>
              </li>
            </template>
          </ul>
        </nav>
        <div class="summary-wrapper">
          <template v-for="person in insuredPersons" :key="person.ID">
            <div class="summary-inner" v-show="person.ID == currentPerson">
              <OptionsSummaryBody :pid="person.ID"></OptionsSummaryBody>
            </div>
          </template>
        </div>
      </div>
    </section>
    <section class="simulation-options">
      <div class="c-inner">
        <p class="options-catch">
          年齢や家族構成に応じた保障を<br />考えることが大切です！
        </p>
        <div class="options-wrapper">
          <template v-for="person in insuredPersons" :key="person.ID">
            <div class="options-inner" v-show="person.ID == currentPerson">
              <OptionForm
                product="seimei"
                :pid="person.ID"
                @update-condition="subtotalSeimei[person.ID] = $event"
                @update-validation="
                  updateValidation(person.ID, 'seimei', $event)
                "
              ></OptionForm>
              <OptionForm
                product="seikatsu"
                :pid="person.ID"
                @update-condition="subtotalSeikatsu[person.ID] = $event"
                @update-validation="
                  updateValidation(person.ID, 'seikatsu', $event)
                "
              ></OptionForm>
              <p class="options-catch options-catch--additional">
                追加プランで更に充実した保障をプラス。<br />貯蓄や節税で未来への備えを。
              </p>
              <OptionForm
                product="shushin"
                :pid="person.ID"
                @update-condition="subtotalShushin[person.ID] = $event"
                @update-validation="
                  updateValidation(person.ID, 'shushin', $event)
                "
              ></OptionForm>
              <OptionForm
                v-show="person.ID === 'p1'"
                product="tsumitate"
                :pid="person.ID"
                @update-condition="subtotalTsumitate[person.ID] = $event"
                @update-validation="
                  updateValidation(person.ID, 'tsumitate', $event)
                "
              ></OptionForm>
            </div>
          </template>
        </div>
      </div>
    </section>
    <section class="simulation-result">
      <div class="result-inner">
        <div class="result-left">
          <div class="result-fee">
            <p class="result-fee__title">
              月々の<br />保険料({{ thePersonLabel }})
            </p>
            <p class="result-fee__price">
              {{ priceFormat(total) }}<span>円</span>
            </p>
          </div>
          <div class="result-pension">
            <p class="result-pension__title">積立年金</p>
            <p class="result-pension__price">
              {{ priceFormat(totalTsumitate) }}<span>円</span>
            </p>
          </div>
        </div>
        <div class="result-right">
          <button
            type="button"
            :class="'result-next' + (validated ? '' : ' --off')"
            @click="clickNext()"
          >
            内容ご確認<br class="u-for-sp" />画面へ
          </button>
        </div>
      </div>
    </section>
  </div>
  <button @click="move('main')" class="simulation-fixed-btn">
    前画面に<br />戻る
  </button>
</template>

<script>
import OptionForm from "./OptionForm.vue";
import OptionsSummaryBody from "./OptionsSummaryBody.vue";
import {
  GENDER_LABELS,
  PERSON_LABELS,
  LIFESTAGE_LABELS,
  INS_PRODUCTS_LABELS,
} from "@/const.js";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  name: "TheOptions",
  components: {
    OptionForm,
    OptionsSummaryBody,
  },
  props: {},
  data() {
    return {
      currentPerson: "p1",
      subtotalSeimei: { p1: 0, p2: 0, p3: 0, p4: 0 },
      subtotalSeikatsu: { p1: 0, p2: 0, p3: 0, p4: 0 },
      subtotalShushin: { p1: 0, p2: 0, p3: 0, p4: 0 },
      subtotalTsumitate: { p1: 0, p2: 0, p3: 0, p4: 0 },
      validatedState: [
        {
          pid: "p1",
          options: [
            { id: "seimei", value: false },
            { id: "seikatsu", value: false },
            { id: "shushin", value: false },
            { id: "tsumitate", value: false },
          ],
        },
        {
          pid: "p2",
          options: [
            { id: "seimei", value: false },
            { id: "seikatsu", value: false },
            { id: "shushin", value: false },
            { id: "tsumitate", value: false },
          ],
        },
        {
          pid: "p3",
          options: [
            { id: "seimei", value: false },
            { id: "seikatsu", value: false },
            { id: "shushin", value: false },
            { id: "tsumitate", value: false },
          ],
        },
        {
          pid: "p4",
          options: [
            { id: "seimei", value: false },
            { id: "seikatsu", value: false },
            { id: "shushin", value: false },
            { id: "tsumitate", value: false },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getPerson",
      "getPrice",
      "getOptionPrice",
      "getValueFromLabel",
      "isInsuredPerson",
      "isInsuredProduct",
      "priceFormat",
      "getFormValues",
    ]),
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    lifestages() {
      return LIFESTAGE_LABELS;
    },
    insProducts() {
      return INS_PRODUCTS_LABELS;
    },
    isInsured() {
      return (pid) => {
        return this.getPerson(pid).insured;
      };
    },
    insuredPersons() {
      return this.persons.filter((p) => this.isInsured(p.ID));
    },
    thePersonLabel() {
      return this.persons.find((p) => p.ID === this.currentPerson).LABEL;
    },
    productObj() {
      return (product) => {
        return this.insProducts.find((pro) => pro.ID === product);
      };
    },
    thePerson() {
      return (pid = this.currentPerson) => {
        return this.getPerson(pid);
      };
    },
    getSum() {
      return (product, pid = this.currentPerson) => {
        let sum = 0;
        this.productObj(product).CONDITIONS.forEach((con) => {
          if (con.OPTIONS === undefined) {
            // console.log(this.getPrice(
            //   product + "-" + con.ID,
            //   this.getValueFromLabel(GENDER_LABELS, this.thePerson.gender),
            //   this.thePerson.age,
            //   this.getValueFromLabel(
            //     con.LABELS,
            //     this.thePerson.options[product][con.ID]
            //   )));
            // console.log(con);
            // console.log(this.thePerson(pid).options[product][con.ID]);
            sum += this.getPrice(
              product + "-" + con.ID,
              this.getValueFromLabel(GENDER_LABELS, this.thePerson(pid).gender),
              this.thePerson(pid).age,
              this.getValueFromLabel(
                product + "-" + con.ID === "seimei-course" &&
                  (pid === "p3" || pid === "p4")
                  ? con.LABELS_CHILD
                  : con.LABELS,
                this.thePerson(pid).options[product][con.ID]
              ),
              pid,
            );
          } else {
            let values = [];
            con.OPTIONS.forEach((option) => {
              // console.log(
              //   this.thePerson(pid).options[product][con.ID][option.ID]
              // );
              values.push(
                this.getValueFromLabel(
                  option.LABELS,
                  this.thePerson(pid).options[product][con.ID][option.ID]
                )
              );
            });
            if (values.filter((v) => !!v).length === values.length) {
              sum += this.getOptionPrice(
                product + "-" + con.ID,
                this.getValueFromLabel(
                  GENDER_LABELS,
                  this.thePerson(pid).gender
                ),
                this.thePerson(pid).age,
                values
              );
            }
          }
        });
        return sum;
      };
    },
    total() {
      let sum = 0;
      if (this.isInsuredProduct(this.currentPerson, "seimei")) {
        sum += this.subtotalSeimei[this.currentPerson];
      }
      if (this.isInsuredProduct(this.currentPerson, "seikatsu")) {
        sum += this.subtotalSeikatsu[this.currentPerson];
      }
      if (this.isInsuredProduct(this.currentPerson, "shushin")) {
        sum += this.subtotalShushin[this.currentPerson];
      }
      return sum;
    },
    totalTsumitate() {
      let sum = 0;
      if (this.isInsuredProduct(this.currentPerson, "tsumitate")) {
        sum += this.subtotalTsumitate[this.currentPerson];
      }
      return sum;
    },
    validated() {
      let result = true;
      this.validatedState.forEach((p) => {
        return (
          result &&
          p.options.forEach((o) => {
            return result && o.value;
          })
        );
      });
      return result;
    },
  },
  methods: {
    ...mapMutations(["changePage"]),
    move(next) {
      this.changePage({ next });
    },
    clickNext() {
      this.insuredPersons.forEach((person) => {
        this.$store.commit("updateTotal", {
          personId: person.ID,
          subtotalSeimei: this.isInsuredProduct(person.ID, "seimei")
            ? this.getSum("seimei", person.ID)
            : 0,
          subtotalSeikatsu: this.isInsuredProduct(person.ID, "seikatsu")
            ? this.getSum("seikatsu", person.ID)
            : 0,
          subtotalShushin: this.isInsuredProduct(person.ID, "shushin")
            ? this.getSum("shushin", person.ID)
            : 0,
          subtotalTsumitate: this.isInsuredProduct(person.ID, "tsumitate")
            ? this.getSum("tsumitate", person.ID)
            : 0,
        });
      });
      this.move("result");
    },
    // isInsured(pid) {
    //   return this.$store.getters.getPerson(pid).insured;
    // },
    addHere(pid) {
      return pid === this.currentPerson ? " --here" : "";
    },
    changePerson(pid) {
      this.currentPerson = pid;
      // this.getPid();
    },
    updateValidation(pid, optionId, value) {
      this.validatedState
        .find((p) => p.pid === pid)
        .options.find((o) => o.id === optionId).value = value;
      // console.log(
      //   "updateValidation(pid:" +
      //     pid +
      //     ", optionId:" +
      //     optionId +
      //     ", value:" +
      //     value +
      //     "," +
      //     ")"
      // );
      // console.log(this.validatedState);
    },
    // getPid() {
    //   return this.currentPerson;
    // },
  },
};
</script>

<style scoped lang="scss">
.simulation {
  &-summary {
    position: relative;
    background-color: $color-bg-sub;
    padding-bottom: 40px;
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      border-top: 28px solid $color-orange;
      border-left: 52px solid transparent;
      border-right: 52px solid transparent;
      bottom: 20px;
    }
  }
  &-options {
    background-color: $color-bg-main;
  }
  &-result {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: rgba(0, 92, 131, 0.85);
    @include pc {
      height: 90px;
    }
    @include sp {
      height: 100px;
    }
  }
  &-fixed-btn {
    position: fixed;
    display: block;
    background-color: rgba(230, 0, 18, 0.85);
    color: #fff;
    font-weight: 800;
    @include pc {
      bottom: 150px;
      right: calc((100% - $width-app-pc) / 2 - 100px);
      padding: 40px;
      border-radius: 10px;
    }
    @include sp {
      bottom: 110px;
      right: 0;
      padding: 10px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      @include font-size(12px);
    }
  }
}
.summary {
  &-nav {
    @include pc {
      padding: 0 40px;
    }
  }
  &-list {
    display: flex;
    justify-content: flex-start;
    @include pc {
      gap: 0 20px;
    }
    @include sp {
      gap: 0 10px;
    }
  }
  &-item {
    @include sp {
      width: calc((100% - 10px * 3) / 4);
    }
    &__btn {
      height: 35px;
      background-color: $color-bg-footer;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      font-weight: 800;
      font-size: 12px;
      @include pc {
        width: 103px;
      }
      @include sp {
        width: 100%;
      }
      &.--here {
        background-color: $color-text;
        color: #fff;
        font-size: 14px;
      }
    }
  }
}
.options {
  &-catch {
    font-weight: 800;
    text-align: center;
    color: $color-blue;
    @include pc {
      font-size: 21px;
    }
    @include sp {
      font-size: 16px;
      margin-bottom: 30px;
    }
    &--additional {
      margin-bottom: 70px;
      @include pc {
        font-size: 16px;
      }
      &:after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        border-top: 28px solid #e77400;
        border-left: 52px solid transparent;
        border-right: 52px solid transparent;
        margin-top: 20px;
      }
    }
  }
}
.result {
  &-inner {
    display: flex;
    align-items: flex-end;
    color: #fff;
    line-height: 1;
    @include pc {
      justify-content: center;
      gap: 30px;
      width: $width-app-pc;
      margin: 0 auto;
      padding: 25px 0;
    }
    @include sp {
      justify-content: space-between;
      height: 100%;
      padding: 20px 28px;
    }
  }
  &-next {
    background-color: $color-red;
    color: #fff;
    font-weight: 800;
    border-radius: 5px;
    @include pc {
      padding: 4px 25px;
      font-size: 20px;
    }
    @include sp {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      font-size: 20px;
      line-height: 1.2;
    }
    &.--off {
      background-color: $color-bg-footer;
      &:hover {
        opacity: 1;
        cursor: default;
      }
    }
  }
  &-left {
    display: flex;
    @include pc {
      align-items: flex-end;
      gap: 15px;
    }
    @include sp {
      flex-flow: column;
      justify-content: space-between;
      height: 100%;
    }
  }
  &-right {
    @include sp {
      width: calc(100% - 16px - 172px);
      height: 100%;
    }
  }
  &-fee {
    display: flex;
    @include pc {
      align-items: flex-end;
      gap: 15px;
    }
    @include sp {
      justify-content: space-between;
    }
    &__price {
      font-weight: 800;
      font-size: 27px;
      span {
        font-size: 15px;
      }
    }
  }
  &-pension {
    display: flex;
    align-items: center;
    background-color: #fff;
    color: $color-blue;
    border-radius: 5px;
    height: 24px;
    @include pc {
      gap: 20px;
      padding: 0 20px;
    }
    @include sp {
      justify-content: space-between;
      width: 172px;
      padding: 0 5px;
    }
    &__title {
      &:before {
        content: "+";
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 18px;
        height: 18px;
        background-color: $color-blue;
        color: #fff;
        border-radius: 9999px;
        margin-right: 5px;
      }
    }
    &__price {
      font-weight: 800;
      font-size: 20px;
      span {
        font-size: 15px;
      }
    }
  }
}
</style>